import type { Course } from "@/lib/types";
import { cn } from "@/lib/utils";
import { RevealGroup } from "@/components/ui/Reveal";
import { CourseCard } from "./CourseCard";

export function CourseGrid({
  courses,
  className,
  columns = 3,
  immediate = false,
}: {
  courses: Course[];
  className?: string;
  columns?: 2 | 3 | 4;
  immediate?: boolean;
}) {
  return (
    <RevealGroup
      immediate={immediate}
      className={cn(
        "grid gap-6",
        columns === 2 && "sm:grid-cols-2",
        columns === 3 && "sm:grid-cols-2 lg:grid-cols-3",
        columns === 4 && "sm:grid-cols-2 lg:grid-cols-4",
        className
      )}
    >
      {courses.map((course) => (
        <CourseCard key={course.slug} course={course} />
      ))}
    </RevealGroup>
  );
}
